import { css } from '@emotion/react'
import { ReactNode, memo } from 'react'
import { getThemeSpacing } from '../../styles/appTheme'
import { palette } from '../../styles/colors'

const titleStyles = css({
    borderBottom: `1px solid ${palette.drawerDivider}`,
    paddingBottom: getThemeSpacing(1.5),
    fontWeight: 'bold',
    marginLeft: 0,
    marginRight: 0,
    fontSize: '1rem',
    lineHeight: 1.5,
    color: palette.contrastIcons,
})

interface ITitle {
    bottom: number | string
    top: number | string
    children: ReactNode
}

const Title = memo((props: ITitle) => {
    const { bottom, top, children } = props
    return (
        <p
            css={titleStyles}
            style={{
                marginBottom: bottom,
                marginTop: top,
            }}
        >
            {children}
        </p>
    )
})

export default Title
